import Vue from 'vue'
import App from './App'
import router from './router';
import VuejsDialog from 'vuejs-dialog';
import VueLodash from 'vue-lodash'
import cloneDeep from 'lodash/cloneDeep'
import find from 'lodash/find'
import filter from 'lodash/filter'
import findIndex from 'lodash/findIndex'
import sortBy from 'lodash/sortBy'
import orderBy from 'lodash/orderBy'
import sumBy from 'lodash/sumBy'
import isEqual from 'lodash/isEqual'
import reverse from 'lodash/reverse'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import { BootstrapVue, BootstrapVueIcons} from 'bootstrap-vue'
import api from './api/httpClient'
import { store } from './store/store';
import AsyncComputed from 'vue-async-computed'
import vSelect from 'vue-select';
import VueMultiselect from 'vue-multi-select';


Vue.config.productionTip = false

//import css files
import 'vue-multiselect/dist/vue-multiselect.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@fortawesome/fontawesome-free/css/all.css';
import '@mdi/font/css/materialdesignicons.min.css';

import 'admin-lte/dist/css/adminlte.css';
import '../static/assets/css/Poppins.css';
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
import "devextreme/dist/css/dx.light.css";
import 'vue2-datepicker/index.css';
import "devexpress-richedit/dist/dx.richedit.css";
import 'vue-select/dist/vue-select.css';
import 'vue2-timepicker/dist/VueTimepicker.css'
import 'vue-multi-select/dist/lib/vue-multi-select.css';


//import javasacript files
import jquery from 'jquery';
import 'popper.js';
import 'bootstrap';
import 'admin-lte/dist/js/adminlte.min.js';

// AdminLTE's Layout plugin (initialised on window load) forces .content-wrapper to the sidebar's
// height, and the sidebar is min-height 100% of the page, so after one tall page the two kept each
// other tall and every later page ended with a large empty gap at the bottom. Setting the option
// here (and on <body> in index.html for production builds) turns that auto-height off.
document.body.setAttribute('data-panel-auto-height', 'false');
import CheckUserAction from './components/CheckUserAction.vue';


import Autocomplete from 'v-autocomplete';

import ToggleButton from 'vue-js-toggle-button';


// You need a specific loader for CSS files like https://github.com/webpack/css-loader
/*import 'v-autocomplete/dist/v-autocomplete.css';*/


//import img from adminlte
//import 'admin-lte/dist/img/user2-160x160.jpg';

window.$ = jquery;

Vue.use(VueMoment, {
  moment,
});
// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(AsyncComputed);
Vue.use(VuejsDialog);
Vue.use(Autocomplete);
Vue.use(VueLodash, { name: '$lodash', lodash: { cloneDeep, find, filter, findIndex, sortBy, reverse, sumBy, isEqual, orderBy } });
Vue.use(ToggleButton);

window.addEventListener("storage", (event) => {
  if (event.key === "access_details" && !event.newValue) {
    localStorage.removeItem("access_details");
    window.location.href = "/login";
  }
});

Vue.mixin({
  methods: {
    convertDate: function (value) {
      return moment(value).toDate();
    },
    displayDate: function (value) {
      return moment(value).format('DD/MM/YYYY');
    },
    getStatusName: function (statusId) {
      let list = store.getters.GetReservationConfig.bookingStatuses;
    },
    getBookingSource: function (sourceId) {
      switch (sourceId) {
        case 1:
          return 'Walk In'
          break;
        case 2:
          return 'Corporate'
          break;
        case 3:
          return 'Online Channel'
          break;
        case 4:
          return 'Travel Agent'
          break;
        default:
          return '';
          break
      }

    },
    computeNumberOfNights: function (startDate, endDate) {
      let self = this;
      let newdateStart = new Date(startDate);
      let newdateEnd = new Date(endDate);
      let start = new Date(newdateStart.getFullYear(), newdateStart.getMonth(), newdateStart.getDate());
      let end = new Date(newdateEnd.getFullYear(), newdateEnd.getMonth(), newdateEnd.getDate());
      let Difference_In_Time = end.getTime() - start.getTime();
      let Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

      return Difference_In_Days;
    },
    convertToGmtWithTimeFn: function (value) {
      let tempDate = new Date(value);
      let gmt = store.getters.GetActiveLocation.baseUtcOffset;
      tempDate.setHours(tempDate.getHours() + gmt);

      return moment(tempDate).format('DD/MM/YYYY HH:mm:ss');
    },



    convertToGmtFn: function (value) {
      let tempDate = new Date(value);
      let gmt = store.getters.GetActiveLocation.baseUtcOffset;
      tempDate.setHours(tempDate.getHours() + gmt);

      return moment(tempDate);
    },
    convertToGmtWithTimeNoFormat: function (value) {
      let tempDate = new Date(value);

      let utc_offset = tempDate.getTimezoneOffset();
      tempDate.setMinutes(tempDate.getMinutes() + utc_offset);


      let gmt = store.getters.GetActiveLocation.baseUtcOffset;

      tempDate.setMinutes(tempDate.getMinutes() + (gmt * 60));

      return moment(tempDate);
    },
    //ReservationDetails.vue - splitRoom function
    validateFrontOffice: function () {
      let isFrontOffice = store.getters.GetDepartmentFrontOffice();

      let shiftActive = store.getters.GetActiveShiftFn();


      if (isFrontOffice && shiftActive !== null) {
        return true;
      }
      else if (isFrontOffice && (shiftActive === null || shiftActive === undefined)) {
        return false;
      }

      return true;
    },
    getPaymentCollect: function (id) {
      switch (id) {
        case 1:
          return 'Channel Collect';
          break;
        case 2:
          return 'Property Collect';
          break;
      }
    },
    capitalizeFirstLetter: function (value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    //EditReservation.vue - dailyRateWithDiscountAndNet, discountPercentageLabel
    toFixedWithoutRounding: function(value) {
      //var re = new RegExp('^-?\\d+(?:\.\\d{0,' + (4 || -1) + '})?');
      //return Number(value.toString().match(re)[0]);

      return Number(value.toFixed(2));
    }
  }
});

Vue.filter('convertToGmtWithTime', function (value) {

  let tempDate = new Date(value);
  let gmt = store.getters.GetActiveLocation.baseUtcOffset;
  tempDate.setHours(tempDate.getHours() + gmt);

  return moment(tempDate).format('DD/MM/YYYY HH:mm:ss');

})

Vue.filter('convertToGmt', function (value) {
  let tempDate = new Date(value);
  let gmt = store.getters.GetActiveLocation.baseUtcOffset;
  tempDate.setTime(tempDate.getTime() + gmt);

  return tempDate;

})

api.defaults.timeout = 40000;

api.interceptors.request.use(
  config => {
    const token = JSON.parse(localStorage.getItem("access_details"));
    if (token) {
      config.headers.common['Authorization'] = `Bearer ${token.accessToken}`;
      //if (config.params !== undefined)
      //  config.params['userId'] = token.userId;
      //else
      //  config.params = { userId: token.userId };

    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  response => {
    if (response.status === 200 || response.status === 201) {
      return Promise.resolve(response);
    } else {
      localStorage.removeItem('access_details');
      router.replace({
        path: "/login"
      });
      return Promise.reject(response);
    }
  },
  error => {
    if (error.response) {
      if (error.response.status) {
        switch (error.response.status) {
          case 400:
            //do something
            break;

          case 401:
          case 403:
        
            localStorage.removeItem('access_details');
            router.replace({
              path: "/login"
            });
            
            break;
          case 404:
            alert('page not exist');
            break;
          case 502:
            setTimeout(() => {
              router.replace({
                path: "/login",
                query: {
                  redirect: router.currentRoute.fullPath
                }
              });
            }, 1000);
        }
        return Promise.reject(error.response);
      }
    }
  }
);
Vue.component('v-select', vSelect);
Vue.component('check-user-action', CheckUserAction);
Vue.component('multi-select', VueMultiselect)



/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  store,
  router
})



// WEBPACK FOOTER //
// ./src/main.js